<div class="col-sm-12 p-4">
    <div class=" m-0">
      <div class="container-fluid">
        <div class="row">
          <div >
            <div class="row" >
                <div class="row col-12">
                    <!--Penalty-*ngIf="decsionId==2

                                 *ngIf="
       (roleId == 4 && DecsionOList == null)
                     "



    *ngIf="

                                   caseObject.optioans.allowToDeletePenalties
                                   && (roleId == 4 && DecsionOList == null)"
                             -->
                    <div class="row col-12">
                        <!--<h4 class="text-center">{{ "Penalties" | translate }}</h4>
                        <br />-->
                        <div class="card">
                            <div class="row">
                                <div class="col-12">
                                    <button (click)="CreatePenalty(AddPenalty)"
                                             *ngIf="caseObject!=null && caseObject.optioans.allowToAddPenalties && roleId == 4"

                                            class="btn btn-secondary m-2">
                                        <i class="fa fa-plus"></i> {{ "InsertPenalty" | translate }}
                                    </button>
                                </div>
                            </div>
                            <div class="card-body">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">{{'Recivers' | translate }}</th>
                                            <th scope="col">{{'OffenderType' | translate }}</th>
                                            <th scope="col">{{'Description' | translate }}</th>
                                            <th scope="col">{{ "PenaltyTitle" | translate }}</th>
                                            <th scope="col">{{ "SadadNumber" | translate }}</th>
                                            <th scope="col">{{ "PenaltyAmount" | translate }}</th>
                                            <th scope="col">{{'SadadStatus' | translate }}</th>
                                            <th scope="col" *ngIf="caseObject &&caseObject.caseStatusId ===9">{{'ReportingDetails' | translate }}</th>
                                            <!-- <th scope="col"
      (

      roleId != 6 && (roleId == 7 && DecsionOList == null)
    ">

                {{ "Edit" | translate }}
              </th> -->


                                        <th *ngIf="caseObject!=null && caseObject.optioans.allowToAddPenalties && roleId == 4 ">
                                            {{ "Edit" | translate }}
                                        </th>



                                            <th scope="col" *ngIf="caseObject!=null && caseObject.optioans.allowToAddPenalties && roleId == 4 ">

                                                {{ "Delete" | translate }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of CasePenaltiesList">
                                            


                                            <td>
                                                {{ item.caseOffenderName }}
                                            </td>
                                            <td>
                                                {{item.caseOffenderTypeName}}
                                            </td>

                                            <td>
                                              <p style="margin-bottom: 0;"><span style="font-weight: bold;">وصف العقوبة</span> {{ item.description }}</p>
                                              <p><span style="font-weight: bold;">{{'Case' | translate }}</span> {{ item.violationName }}</p>
                                            </td>
                                            <td>{{ item.penaltyTitle }}  - {{item.isFinancial?"مالية":"ادارية"}}</td>
                                            <td>{{ item.sadadNumber }}</td>
                                            <td *ngIf="item.amount==0"> __ </td>
                                            <td *ngIf="item.amount!=0">{{ item.amount }}</td>

                                            <td>{{ item.isFinancial?   item.invoiceStatusName  : "-" }}</td>

                                            <td *ngIf="caseObject &&caseObject.caseStatusId ===9">
                                                <a  (click)="ShowRecivers(item, Recivers)">
                                                    <i class="fa fa-users"></i>
                                                </a>
                                               
                                            </td>

                                            <!-- <td *ngIf="

      caseObject.optioans.allowToEditPenalties
    && (roleId == 7 && DecsionOList == null)">
                <a (click)="EditPenalty(item, Edit)">
                  <i class="fa fa-edit"></i>
                </a>
              </td>

                 *ngIf="

      caseObject.optioans.allowToDeletePenalties
      && (roleId == 4 && DecsionOList == null)">


                  -->

                                            <td *ngIf="caseObject!=null && caseObject.optioans.allowToAddPenalties && roleId == 4 ">
                                                <a class="m-2" (click)="EditPenalty(item, Edit)">
                                                    <i class="fa fa-edit"></i>
                                                </a>
                                            </td>


                                            <td *ngIf="caseObject!=null && caseObject.optioans.allowToAddPenalties && roleId == 4 ">
                                                <a (click)="DeletePenalty(item, mymodal)">
                                                    <i class="fa fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!--End Penalities-->
                </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  
  
    <ng-template #AddPenalty let-modal>
      <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
          {{ "InsertPenalty" | translate }}
        </h4>
      </div>
      <div class="modal-body">
        <div class="custom-form">
          <div class="col-12 offset-1 my-4">
            
            <div class="col-12 row ">
              <p style="font-weight: bold">
                {{ "typePenalty" | translate }}
              </p>
              <ng-select [items]="PenaltyArr" bindLabel="penaltyTitle" bindValue="penaltyId" class="form-control-select"
                [(ngModel)]="penaltyId" [ngModelOptions]="{ standalone: true }" (change)="selectItem($event)"
                placeholder="{{ 'typePenalty' | translate }}">
              </ng-select>
            </div>
            <div class="col-12 row mt-3">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label for="">{{ "PenaltyDescription" | translate }} : </label>
                <span *ngIf="Desc.invalid" class="alert"
                  style="color: #ff0000; white-space: nowrap; line-height: 0">
                  <div *ngIf="Desc.errors?.required">*</div>
                  <div *ngIf="Desc.errors?.pattern">
                    {{ "ThisIsNotValidDescription" | translate }}
                  </div>
                </span>
              </div>

              <textarea [(ngModel)]="penaltyDescription" class="form-control"
                pattern="^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s-_]*$"
                name="penaltyDescription" required #Desc="ngModel"></textarea>
            </div>
            <div class="row col-12 mt-3">
              <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                  <label for="Violation"> {{'Case' | translate }} </label>
                  <span *ngIf="Violation.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                      <div *ngIf="Violation.errors?.required">
                          *
                      </div>
                  </span>
              </div>
              <ng-select required #Violation="ngModel" id="Violation" class="form-control-select" [items]="violationArr" bindLabel="text" bindValue="id"
                         [(ngModel)]="violationId" [ngModelOptions]="{standalone: true}" placeholder="{{'Case' | translate }}">
              </ng-select>
            </div>
            
            <div class="row col-12 mt-3">
              <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                  <label for="OffenderType">{{'OffenderType' | translate }} </label>
                  <span *ngIf="OffenderType.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                      <div *ngIf="OffenderType.errors?.required">
                          *
                      </div>
                  </span>
              </div>
              <ng-select (change)="caseOffenderTypeIdSelected($event)" required #OffenderType="ngModel" id="OffenderType" class="form-control-select" [items]="TypesArr" bindLabel="text" bindValue="id"
                         [(ngModel)]="caseOffenderTypeId" [ngModelOptions]="{standalone: true}" placeholder="{{'OffenderType' | translate }}">
              </ng-select>
            </div>
            <div  class="col-12 row mt-3">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label for="offenderName">{{'Offender' | translate }}</label>
              </div>
  
             <ng-select
              [disabled]="caseOffenderTypeId==undefined || caseOffenderTypeId==null"
              class="form-control-select"
              [items]="OffenderList"
              bindLabel="offenderName"
              bindValue="offenderId"
              [(ngModel)]="offenderIds"
              required
              #Offenders="ngModel"
              [ngModelOptions]="{ standalone: true }"
              placeholder="{{ 'offenderName' | translate }} "
            >
            </ng-select> 
              <!--<input type="text" readonly [(ngModel)]="this.OffenderList[0].offenderName" id="offenderName"
                class="form-control">-->
  
            </div>
  
            <br />
            <div class="custom-control custom-checkbox">

                <span *ngIf="isFinancial&&penaltyId>0">{{'typePenalty' | translate }} : عقوبة مالية</span>
                <span *ngIf="(!isFinancial) && penaltyId>0">{{'typePenalty' | translate }} : عقوبة ادارية</span>

 
            </div>
           
            <div class="col-12 row mt-3">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label for="amoutPenalty">{{ "PenaltyAmount" | translate }}</label>
              </div>
              
              <input [readonly]="!isFinancial" #AmoutPenalty="ngModel" [(ngModel)]="amount" type="number" class="form-control" id="amoutPenalty" min="{{minAmountPenality}}"  max="{{maxAmountPenality}}"
                name="amoutPenalty" required [ngModelOptions]="{ standalone: true }"/>
                <span
                *ngIf="AmoutPenalty.invalid"
                class="alert"
                style="
                  color: red;
                  white-space: nowrap;
                  line-height: 0;
                  padding: 0;
                  margin-top: 8px;
                "
              >
                <div *ngIf="AmoutPenalty.errors?.min">{{'AmountPenaltyMinFromPenalty' | translate }}({{minAmountPenality}}) </div>
                <div *ngIf="AmoutPenalty.errors?.max"> {{'AmountPenaltyMaxFromPenalty' | translate }} ({{maxAmountPenality}})</div>

              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="OffenderType.invalid || Desc.invalid || (isFinancial == true && AmoutPenalty.invalid ) || Offenders.invalid || Violation.invalid" type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="OnCreatePenalty()">
          {{ "Add" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="notCreatePenalty()">
          {{ "NO" | translate }}
        </button>
      </div>
    </ng-template>
  
    <ng-template #mymodal let-modal>
      <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
          {{ "ConfirmDeleteOperation" | translate }}
        </h4>
      </div>
      <div class="modal-body text-center">
        <p>{{ "SelectedRecordwillbeDeleted" | translate }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDeletePenalty()">
          {{ "YES" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')" (click)="deleteChecked()">
          {{ "NO" | translate }}
        </button>
      </div>
    </ng-template>
  
    <ng-template #Edit let-modal>
      <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
          تعديل العقوبة
        </h4>
      </div>
      <div class="modal-body">
        <div class="custom-form">
          <div class="col-12 offset-1 my-4">
            
            <div class="col-12 row mt-3">
              <p style="font-weight: bold">
                {{ "typePenalty" | translate }}
              </p>
              <ng-select [items]="PenaltyArr" bindLabel="penaltyTitle" bindValue="penaltyId" class="form-control-select"
                [(ngModel)]="casePenaltyEdited.penaltyId" [ngModelOptions]="{ standalone: true }" (change)="selectItem($event)"
                placeholder="{{ 'typePenalty' | translate }}">
              </ng-select>
            </div>
            <div class="col-12 row mt-3">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label for="">{{ "PenaltyDescription" | translate }} : </label>
                <span *ngIf="PenaltyDescription.invalid" class="alert"
                  style="color: #ff0000; white-space: nowrap; line-height: 0">
                  <div *ngIf="PenaltyDescription.errors?.required">*</div>
                  <div *ngIf="PenaltyDescription.errors?.pattern">
                    {{ "ThisIsNotValidDescription" | translate }}
                  </div>
                </span>
              </div>

              <textarea [(ngModel)]="casePenaltyEdited.description" class="form-control"
                pattern="^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s-_]*$"
                name="penaltyDescription" required #PenaltyDescription="ngModel"></textarea>
            </div>
            <div class="row col-12 mt-3">
              <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                  <label for="Violation"> {{'Case' | translate }} </label>
                  <span *ngIf="Violation.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                      <div *ngIf="Violation.errors?.required">
                          *
                      </div>
                  </span>
              </div>
              <ng-select required #Violation="ngModel" id="Violation" class="form-control-select" [items]="violationArr" bindLabel="text" bindValue="id"
                         [(ngModel)]="casePenaltyEdited.violationId" [ngModelOptions]="{standalone: true}" placeholder="{{'Case' | translate }}">
              </ng-select>
            </div>
  
            <div class="row col-12 mt-3">
              <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                  <label for="OffenderType">{{'OffenderType' | translate }} </label>
                  <span *ngIf="OffenderType.invalid" class="alert" style="color: red; white-space: nowrap;line-height: 0; padding: 0; margin-top: 8px;">
                      <div *ngIf="OffenderType.errors?.required">
                          *
                      </div>
                  </span>
              </div>
              <ng-select (change)="caseOffenderTypeIdSelected($event)" required #OffenderType="ngModel" id="OffenderType" class="form-control-select" [items]="TypesArr" bindLabel="text" bindValue="id"
                         [(ngModel)]="casePenaltyEdited.caseOffenderTypeId" [ngModelOptions]="{standalone: true}" placeholder="{{'OffenderType' | translate }}">
              </ng-select>
            </div>
            <div class="col-12 row mt-3">
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label for="offenderName">{{'Offenders' | translate }}</label>
              </div>
  
             <ng-select
              [disabled]="casePenaltyEdited.caseOffenderTypeId==undefined || casePenaltyEdited.caseOffenderTypeId==null"
              class="form-control-select"
              [items]="casePenaltyEdited.casePenaltyOffenders"
              bindLabel="offenderName"
              bindValue="offenderId"
              [(ngModel)]="offenderEdited"
              #OFFENDEREdit="ngModel"
              [ngModelOptions]="{ standalone: true }"
              placeholder="{{ 'offenderName' | translate }} "
            >
            </ng-select> 
              <!--<input type="text" readonly [(ngModel)]="this.OffenderList[0].offenderName" id="offenderName"
                class="form-control">-->
  
            </div>
  
            <br />
            <div class="custom-control custom-checkbox">

                <span *ngIf="casePenaltyEdited.isFinancial">{{'typePenalty' | translate }} : عقوبة مالية</span>
                <span *ngIf="!casePenaltyEdited.isFinancial">{{'typePenalty' | translate }} : عقوبة ادارية</span>

                 
            </div>
           
            <div class="col-12 row mt-3" >
              <div style="display: flex; flex-wrap: nowrap; height: 30px">
                <label for="amount">{{ "PenaltyAmount" | translate }}</label>
              </div>
              <input [readonly]="!isFinancial" #AmoutPenalty="ngModel" #name="ngModel" [(ngModel)]="casePenaltyEdited.amount" type="number" class="form-control" id="amount" min="{{minAmountPenality}}"  max="{{maxAmountPenality}}"
                name="amount" required />
                <span
                *ngIf="AmoutPenalty.invalid"
                class="alert"
                style="
                  color: red;
                  white-space: nowrap;
                  line-height: 0;
                  padding: 0;
                  margin-top: 8px;
                "
              >
                <div *ngIf="AmoutPenalty.errors?.min">{{'AmountPenaltyMinFromPenalty' | translate }}({{minAmountPenality}})</div>
                <div *ngIf="AmoutPenalty.errors?.max">{{'AmountPenaltyMaxFromPenalty' | translate }} ({{maxAmountPenality}})</div>

              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" [disabled]="OffenderType.invalid|| Violation.invalid|| PenaltyDescription.invalid || (isFinancial == true && AmoutPenalty.invalid ) || OFFENDEREdit.invalid" (click)="onEditPenalty()">
          {{ "Edit" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
          {{ "NO" | translate }}
        </button>
      </div>
    </ng-template>
  
    <ng-template #Recivers let-modal>
      <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
          {{'ReportingDetails' | translate }}
        </h4>
        <a style="position: absolute;left:50px" (click)="print()" class="btn btn-outline-dark">
          <i class="fa fa-print"></i> {{'Print' | translate }}
        </a>

      </div>
      <div class="modal-body text-center">
        <table class="table table-striped" *ngIf="Recivers1.length > 0">
          <thead>
              <tr>
                  <th scope="col">{{ "NationalIdentity" | translate }}</th>
                  <th scope="col">{{ "OffenderName" | translate }}</th>
                  <th scope="col">{{'Message' | translate }}</th>
                  <th scope="col">{{'ReportingDate' | translate }}</th>
                  
                  <th scope="col">{{ "Seen" | translate }}</th> 
              </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item1 of Recivers1">
              <td>{{ item1.nid }}</td>
              <td>{{ item1.name }}</td>
              <td>
                  <p style="direction: ltr">
                      {{ item1.nabaaMessage }}
                  </p>
              </td>
              <td>
                  {{ item1.createdOn | toDateTime}}

              </td>
              <td>
                <i *ngIf="item1.isViewed" class="available fa fa-check-circle"></i>
                <i *ngIf="!item1.isViewed" class="fa fa-times"></i>

                <p *ngIf="item1.isViewed">   {{ item1.viewedOn | toDateTime }} </p>
              </td>
            </tr>
          </tbody>
        </table>
        <!--<h3 style="text-align: center;" *ngIf="Recivers1.length == 0">
          عفواً لا تظهر تفاصيل المبلغيين الا بعد إصدار القرار
        </h3>-->
      </div>
      <div class="modal-footer" style="justify-content: end">
        <button class="btn btn-danger" (click)="modal.close()">{{'Close'|translate}}</button>
      </div>

    </ng-template>
 
 
  </div>

 
